//? 이메일에서 연장 요청을 클릭했을 때 보여지는 페이지

import { sendMeetingExtendsResponse } from "apis/meeting/back-office";
import { useToast } from "hook/useToast";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AlertModal from "uis/modal/alert-modal";
import { LoadingModal } from "uis/modal";
import RejectExtendModal from "./modals/reject-extend-modal";

const ExtendsRequest = () => {
  const { id, state } = useParams<{ id: string; state: string }>();
  const [openRejectModal, setOpenRejectModal] = useState<boolean>(false);
  const [openAcceptModal, setOpenAcceptModal] = useState<boolean>(false);
  const { showToast } = useToast();

  useEffect(() => {
    if (state === "reject" && id) {
      setOpenRejectModal(true);
    } else if (state === "accept" && id) {
      setOpenAcceptModal(true);
    }
  }, []);

  return (
    <>
      <LoadingModal modalIsOpen={true} />
      <RejectExtendModal
        openModal={openRejectModal}
        onHandleCancel={async () => {
          if (id && state === "reject") {
            const res = await sendMeetingExtendsResponse(id, false);
            if (res.success) {
              alert("연장 요청이 거절되었습니다.");
              window.close();
            } else {
              showToast("연장 요청을 처리할 수 없습니다.", "error");
            }
          }
        }}
        closeModal={function (): void {
          throw new Error("Function not implemented.");
        }}
      />
      <AlertModal
        content={"회의 참석자들에게 변경된 회의 시간이 안내됩니다."}
        title={"예약 연장 요청을 수락하시겠습니까?"}
        modalIsOpen={openAcceptModal}
        btnTitle="연장 요청 수락하기"
        onChange={() => {
          if (id && state === "accept")
            sendMeetingExtendsResponse(id, true).then((res) => {
              if (res.success) {
                alert("연장 요청을 수락하셨습니다.");
                window.close();
              } else {
                showToast("연장 요청을 처리할 수 없습니다.", "error");
              }
            });
        }}
        closeModal={() => {}}
      />
    </>
  );
};

export default ExtendsRequest;
